// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUpdateAccountVerificationStatusDto
 */
export interface IUpdateAccountVerificationStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IUpdateAccountVerificationStatusDto
     */
    elevate_account_id: number;
    /**
     * 
     * @type {string}
     * @memberof IUpdateAccountVerificationStatusDto
     */
    status: IUpdateAccountVerificationStatusDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IUpdateAccountVerificationStatusDtoStatusEnum {
    AUTOMATICALLY_VERIFIED = 'AUTOMATICALLY_VERIFIED',
    PENDING_AUTOMATIC_VERIFICATION = 'PENDING_AUTOMATIC_VERIFICATION',
    PENDING_MANUAL_VERIFICATION = 'PENDING_MANUAL_VERIFICATION',
    MANUALLY_VERIFIED = 'MANUALLY_VERIFIED',
    VERIFICATION_EXPIRED = 'VERIFICATION_EXPIRED',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    DATABASE_MATCHED = 'DATABASE_MATCHED',
    DATABASE_INSIGHTS_PASS = 'DATABASE_INSIGHTS_PASS',
    DATABASE_INSIGHTS_PASS_WITH_CAUTION = 'DATABASE_INSIGHTS_PASS_WITH_CAUTION',
    DATABASE_INSIGHTS_FAIL = 'DATABASE_INSIGHTS_FAIL',
    DATABASE_INSIGHTS_PENDING = 'DATABASE_INSIGHTS_PENDING',
    INSTANTLY_VERIFIED = 'INSTANTLY_VERIFIED'
}


/**
 * Check if a given object implements the IUpdateAccountVerificationStatusDto interface.
 */
export function instanceOfIUpdateAccountVerificationStatusDto(value: object): value is IUpdateAccountVerificationStatusDto {
    if (!('elevate_account_id' in value) || value['elevate_account_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function IUpdateAccountVerificationStatusDtoFromJSON(json: any): IUpdateAccountVerificationStatusDto {
    return IUpdateAccountVerificationStatusDtoFromJSONTyped(json, false);
}

export function IUpdateAccountVerificationStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdateAccountVerificationStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'elevate_account_id': json['elevate_account_id'],
        'status': json['status'],
    };
}

export function IUpdateAccountVerificationStatusDtoToJSON(json: any): IUpdateAccountVerificationStatusDto {
    return IUpdateAccountVerificationStatusDtoToJSONTyped(json, false);
}

export function IUpdateAccountVerificationStatusDtoToJSONTyped(value?: IUpdateAccountVerificationStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'elevate_account_id': value['elevate_account_id'],
        'status': value['status'],
    };
}

